export default "/images/82ae475878f6cefc9bbf0ec2851613b8.png";